/**
 * Filters and ranks list options by search query relevance:
 * - Empty query: returns options in original order.
 * - Non-empty query:
 *   1. Priority 1: Starts with query (e.g., "v" -> "Valant", "Varian", etc.)
 *   2. Priority 2: Word inside starts with query (e.g., "Practice Velocity" for "v")
 *   3. Priority 3: Contains query anywhere else (only for 3+ letter queries to avoid noisy single-letter matches)
 *   Within each priority level, items are sorted alphabetically.
 */
export function filterAndSortList(options, query) {
  const q = (query || "").trim().toLowerCase();
  const list = Array.isArray(options) ? options : [];

  if (!q) {
    return list;
  }

  const prefixMatches = [];
  const wordPrefixMatches = [];
  const containsMatches = [];

  for (const item of list) {
    const val = typeof item === "string" ? item.trim() : (item?.value || item?.label || "").trim();
    if (!val) continue;
    const lower = val.toLowerCase();

    if (lower.startsWith(q)) {
      prefixMatches.push(val);
    } else {
      // Check word boundaries: spaces, slashes, hyphens, parentheses, etc.
      const words = lower.split(/[\s/(),.-]+/);
      if (words.some((w) => w && w.startsWith(q))) {
        wordPrefixMatches.push(val);
      } else if (q.length >= 3 && lower.includes(q)) {
        containsMatches.push(val);
      }
    }
  }

  prefixMatches.sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }));
  wordPrefixMatches.sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }));
  containsMatches.sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }));

  return [...prefixMatches, ...wordPrefixMatches, ...containsMatches];
}
